module.exports = __webpack_public_path__ + "img/OGBull.05516.80c5f6ac.webp";